import { Eye } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';
import { Label } from '@nucleus-commerce/ui/components/label';
import { Switch } from '@nucleus-commerce/ui/components/switch';

import { useSectionPreview } from '../hooks/use-sections';

import { PreviewPayloadSheet } from './preview/preview-payload-sheet';

export interface SectionPreviewSheetProps {
  storeId: string;
  sectionId: string;
  handle: string;
}

/**
 * Exactly what a storefront receives from GET /storefront/v1/sections/{handle}, drafts
 * included, so a developer can see the payload before wiring a page to it.
 */
export function SectionPreviewSheet({ storeId, sectionId, handle }: SectionPreviewSheetProps) {
  const { t } = useTranslation('content');
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState(true);
  const query = useSectionPreview(
    storeId,
    sectionId,
    { products: products ? 'true' : 'false' },
    open,
  );

  return (
    <PreviewPayloadSheet
      open={open}
      onOpenChange={setOpen}
      trigger={
        <Button type="button" variant="outline" data-tour="content.section-editor.preview">
          <Eye aria-hidden />
          {t('preview.open')}
        </Button>
      }
      title={t('preview.title')}
      description={
        <>
          {t('preview.description')} <code>GET /storefront/v1/sections/{handle}</code>
        </>
      }
      label={t('preview.payload')}
      payload={query.data}
      isPending={query.isPending}
      error={query.isError ? query.error : undefined}
      controls={
        <>
          <Switch id="preview-products" checked={products} onCheckedChange={setProducts} />
          <Label htmlFor="preview-products">{t('preview.withProducts')}</Label>
        </>
      }
    />
  );
}
